import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { Dialog } from '@modernloop/shared/components';
import { Stack, Typography } from '@mui/material';

type MissingSelfScheduleLinkTokenModalProps = {
  onAppendAndContinue: () => void;
  goBack: () => void;
};

const MissingSelfScheduleLinkTokenModal = ({ onAppendAndContinue, goBack }: MissingSelfScheduleLinkTokenModalProps) => {
  const { t } = useTranslation();

  return (
    <Dialog
      open
      title={t('hiring-dashboard-candidates:candidates.missingToken.title')}
      submitOptions={{
        label: t('hiring-dashboard-candidates:candidates.missingToken.appendAndSend'),
        onClick: onAppendAndContinue,
      }}
      cancelOptions={{
        label: t('hiring-dashboard-common:common.cancel'),
        onClick: goBack,
      }}
    >
      <Stack spacing={2}>
        <Typography>
          {t('hiring-dashboard-schedule:schedule.missingSelfScheduleLinkToken.body', {
            token: '{{SELF_SCHEDULE_LINK}}',
          })}
        </Typography>
        <Typography color="text.secondary">
          {t('hiring-dashboard-schedule:schedule.missingSelfScheduleLinkToken.example')}
        </Typography>
      </Stack>
    </Dialog>
  );
};

export default MissingSelfScheduleLinkTokenModal;
